{
  "asset_id": "f920d7d4-8705-4ef3-bd6c-ddcc13b9d5bd",
  "content_type": "image/png",
  "created_at": "2026-07-25T01:03:35Z",
  "original_filename": "anna-quilting.png",
  "project_id": "5631f878-f260-4e6b-83e7-e028c592d745",
  "r2_key": "a/v1/5631f878-f260-4e6b-83e7-e028c592d745/f920d7d4-8705-4ef3-bd6c-ddcc13b9d5bd/anna-quilting.png",
  "size": 2873542,
  "url": "/__l5e/assets-v1/f920d7d4-8705-4ef3-bd6c-ddcc13b9d5bd/anna-quilting.png",
  "version": 1
}